var map = {
	"./001-food.png": "67fa",
	"./002-life-insurance.png": "12b0",
	"./003-washing-machine.png": "b814",
	"./004-living-room.png": "a54e",
	"./005-milk.png": "2fc2",
	"./006-first-aid-kit.png": "5390",
	"./007-car.png": "676b",
	"./008-construction.png": "5166",
	"./009-university.png": "381e",
	"./010-dress.png": "890a",
	"./011-feeder.png": "b4d6",
	"./012-cleaning.png": "d941",
	"./013-makeup.png": "e89a",
	"./014-dish.png": "6ccb",
	"./015-clipboards.png": "7e3a",
	"./active-icon-black.png": "efd0",
	"./active-icon.png": "e55e",
	"./camera-border.png": "5f18",
	"./close.png": "f096",
	"./danger.png": "7764",
	"./edit-b.png": "a438",
	"./edit.png": "dc65",
	"./email-b.png": "522f",
	"./email.png": "aef1",
	"./employees.png": "841f",
	"./error.png": "bb31",
	"./exchange.png": "6e29",
	"./help.png": "c2d1",
	"./log.png": "8172",
	"./log_w.png": "703e",
	"./logomini.png": "6e26",
	"./mail.png": "a336",
	"./menu-b.png": "c68a",
	"./menu-w.png": "b4ea",
	"./menu.png": "7121",
	"./mobile-logo.png": "15e2",
	"./myqr.png": "6a40",
	"./nomin-logo-hands.png": "5ec7",
	"./pass.png": "af75",
	"./print.png": "3f40",
	"./right-arrow.png": "9748",
	"./shapes-and-symbols.png": "6d56",
	"./spin.png": "22d4",
	"./success.png": "7be6",
	"./tick.png": "ac58",
	"./user.png": "fc48",
	"./user_w.png": "e299",
	"./whiteclose.png": "23f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";